export const categories = [
  { slug: 'all', name: '全部', description: '浏览所有韩漫作品' },
  { slug: 'romance', name: '恋爱', description: '甜蜜浪漫的恋爱韩漫' },
  { slug: 'fantasy', name: '奇幻', description: '奇幻世界冒险韩漫' },
  { slug: 'action', name: '热血', description: '热血刺激的动作韩漫' },
  { slug: 'drama', name: '剧情', description: '深度剧情的韩漫佳作' },
  { slug: 'comedy', name: '搞笑', description: '轻松搞笑的韩漫作品' },
  { slug: 'thriller', name: '悬疑', description: '悬疑惊悚韩漫推荐' },
  { slug: 'bl', name: 'BL', description: '人气BL韩漫作品' },
];

export const comics = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / Dubu',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20solo%20leveling%20warrior%20with%20dark%20armor%20holding%20sword%20in%20a%20dungeon%20atmosphere%20dramatic%20lighting%20dynamic%20pose%20professional%20illustration%20clean%20composition%20neutral%20background&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    description: '十年前，世界突然出现了连接异次元与这个世界的"门"，异界中的魔物开始不断侵袭人类。与此同时，部分人类觉醒了超能力，这些人被称为"猎人"。故事的主人公程肖宇是所有猎人中等级最低的E级猎人，在某次突袭中，他和其他猎人被困在了双重地下城中，面临着生死考验...',
    categories: ['action', 'fantasy'],
    chapters: [
      { num: 1, title: '第1话：E级猎人', date: '2024-01-15' },
      { num: 2, title: '第2话：双重地下城', date: '2024-01-22' },
      { num: 3, title: '第3话：系统激活', date: '2024-01-29' },
      { num: 4, title: '第4话：每日任务', date: '2024-02-05' },
      { num: 5, title: '第5话：第一次升级', date: '2024-02-12' },
      { num: 6, title: '第6话：隐藏副本', date: '2024-02-19' },
      { num: 7, title: '第7话：暗影君主', date: '2024-02-26' },
      { num: 8, title: '第8话：新的力量', date: '2024-03-04' },
      { num: 9, title: '第9话：S级觉醒', date: '2024-03-11' },
      { num: 10, title: '第10话：决战前夕', date: '2024-03-18' },
    ],
    rating: 9.7,
    views: 2850000,
    status: '连载中',
    updateDate: '2024-03-18',
    featured: true,
  },
  {
    id: 2,
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20style%20beautiful%20girl%20with%20long%20hair%20applying%20makeup%20in%20mirror%20soft%20pastel%20colors%20school%20uniform%20korean%20webtoon%20art%20illustration%20clean%20simple%20background&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    description: '从小因为外貌被欺负的任朱静，通过化妆技巧实现了完美变身，转学后成为了众人眼中的女神。然而她一直隐藏着自己的真实面貌，害怕被人发现。当两位性格迥异的男神同时出现在她的生活中，她的秘密还能守住吗？',
    categories: ['romance', 'drama', 'comedy'],
    chapters: [
      { num: 1, title: '第1话：新的开始', date: '2024-01-10' },
      { num: 2, title: '第2话：完美的伪装', date: '2024-01-17' },
      { num: 3, title: '第3话：校草出现', date: '2024-01-24' },
      { num: 4, title: '第4话：意外重逢', date: '2024-01-31' },
      { num: 5, title: '第5话：真心还是假意', date: '2024-02-07' },
    ],
    rating: 9.5,
    views: 3200000,
    status: '连载中',
    updateDate: '2024-02-07',
    featured: true,
  },
  {
    id: 3,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20style%20young%20man%20in%20modern%20setting%20with%20mysterious%20book%20glowing%20apocalyptic%20background%20dramatic%20composition%20webtoon%20art%20clean%20illustration%20neutral%20backdrop&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    description: '金独子是一个平凡的上班族，唯一的爱好就是阅读一部名为《在灭亡世界生存的三种方法》的网络小说。当这部小说连载完结的那一天，小说中的世界突然变成了现实。凭借对小说内容的了解，金独子成为了这个世界上唯一知道未来走向的人。',
    categories: ['fantasy', 'action'],
    chapters: [
      { num: 1, title: '第1话：小说完结之日', date: '2024-02-01' },
      { num: 2, title: '第2话：第一个场景', date: '2024-02-08' },
      { num: 3, title: '第3话：主角登场', date: '2024-02-15' },
      { num: 4, title: '第4话：生存指南', date: '2024-02-22' },
      { num: 5, title: '第5话：命运的选择', date: '2024-03-01' },
      { num: 6, title: '第6话：隐藏任务', date: '2024-03-08' },
      { num: 7, title: '第7话：星座的注视', date: '2024-03-15' },
    ],
    rating: 9.8,
    views: 4500000,
    status: '连载中',
    updateDate: '2024-03-15',
    featured: true,
  },
  {
    id: 4,
    title: '我的ID是江南美人',
    author: '淇萌琪',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20style%20elegant%20college%20girl%20with%20natural%20beauty%20on%20campus%20cherry%20blossom%20trees%20soft%20warm%20lighting%20beautiful%20illustration%20clean%20simple%20background&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    description: '姜美来从小因为长相丑陋而饱受欺凌，高中毕业后她决定做整容手术，以全新的面貌开始大学生活。在大学里她遇到了中学同学都景硕，他是唯一知道她过去的人。一段关于外貌、自信与真爱的故事就此展开。',
    categories: ['romance', 'drama'],
    chapters: [
      { num: 1, title: '第1话：全新的我', date: '2024-01-20' },
      { num: 2, title: '第2话：大学生活', date: '2024-01-27' },
      { num: 3, title: '第3话：故人重逢', date: '2024-02-03' },
      { num: 4, title: '第4话：美女的标准', date: '2024-02-10' },
    ],
    rating: 9.3,
    views: 1800000,
    status: '已完结',
    updateDate: '2024-02-10',
    featured: false,
  },
  {
    id: 5,
    title: '鬼灭之刃（韩漫版）',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20style%20warrior%20holding%20katana%20with%20dark%20uniform%20fiery%20background%20intense%20dramatic%20lighting%20dynamic%20illustration%20clean%20composition%20neutral%20backdrop&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    description: '在一个被恶鬼肆虐的世界里，少年炭治郎的家人惨遭恶鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复人类的方法，炭治郎踏上了成为鬼杀队剑士的修炼之路。',
    categories: ['action', 'fantasy', 'drama'],
    chapters: [
      { num: 1, title: '第1话：残忍之夜', date: '2024-02-05' },
      { num: 2, title: '第2话：水之呼吸', date: '2024-02-12' },
      { num: 3, title: '第3话：最终选拔', date: '2024-02-19' },
      { num: 4, title: '第4话：第一个任务', date: '2024-02-26' },
      { num: 5, title: '第5话：浅草之鬼', date: '2024-03-04' },
      { num: 6, title: '第6话：鼓之宅邸', date: '2024-03-11' },
    ],
    rating: 9.6,
    views: 5100000,
    status: '连载中',
    updateDate: '2024-03-11',
    featured: true,
  },
  {
    id: 6,
    title: '看脸时代',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20style%20high%20school%20boy%20split%20personality%20two%20faces%20dark%20and%20light%20contrast%20urban%20setting%20dramatic%20webtoon%20illustration%20clean%20composition%20neutral%20background&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    description: '朴亨锡是一个因肥胖和长相在学校遭受霸凌的高中生。某天他发现自己可以切换成另一个完美外貌的身体。白天是英俊的校草，晚上是受欺负的胖子，双重身份的生活充满了挑战与冒险。',
    categories: ['drama', 'action', 'comedy'],
    chapters: [
      { num: 1, title: '第1话：两个我', date: '2024-01-25' },
      { num: 2, title: '第2话：新学校', date: '2024-02-01' },
      { num: 3, title: '第3话：真实的自己', date: '2024-02-08' },
      { num: 4, title: '第4话：校园风云', date: '2024-02-15' },
      { num: 5, title: '第5话：友情与背叛', date: '2024-02-22' },
    ],
    rating: 9.4,
    views: 2600000,
    status: '连载中',
    updateDate: '2024-02-22',
    featured: false,
  },
  {
    id: 7,
    title: '知道了也無妨',
    author: '李惠',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20style%20two%20handsome%20men%20facing%20each%20other%20tender%20moment%20office%20setting%20warm%20lighting%20soft%20atmosphere%20beautiful%20illustration%20clean%20simple%20background&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    description: '两个在同一家公司工作的男人，一个是冷漠的上司，一个是热情的下属。当工作关系逐渐变成私人感情，他们该如何面对这份不被世俗所理解的感情？一段关于勇气与真爱的故事。',
    categories: ['bl', 'romance', 'drama'],
    chapters: [
      { num: 1, title: '第1话：初遇', date: '2024-02-10' },
      { num: 2, title: '第2话：心动瞬间', date: '2024-02-17' },
      { num: 3, title: '第3话：靠近', date: '2024-02-24' },
      { num: 4, title: '第4话：告白', date: '2024-03-02' },
    ],
    rating: 9.2,
    views: 1500000,
    status: '连载中',
    updateDate: '2024-03-02',
    featured: false,
  },
  {
    id: 8,
    title: '剑尊归来',
    author: '柳城',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20martial%20arts%20style%20swordsman%20in%20traditional%20hanbok%20with%20long%20sword%20ancient%20Korean%20setting%20epic%20atmosphere%20dramatic%20lighting%20illustration%20clean%20composition&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    description: '曾经被誉为天下第一剑的剑尊，在与魔教教主的决战中陨落。百年后，他以少年之身重生归来。面对已经物是人非的武林，他决定重新修炼，夺回属于自己的荣耀。',
    categories: ['action', 'fantasy'],
    chapters: [
      { num: 1, title: '第1话：陨落之剑', date: '2024-01-30' },
      { num: 2, title: '第2话：重生', date: '2024-02-06' },
      { num: 3, title: '第3话：新的征程', date: '2024-02-13' },
      { num: 4, title: '第4话：试剑大会', date: '2024-02-20' },
      { num: 5, title: '第5话：一剑破万法', date: '2024-02-27' },
      { num: 6, title: '第6话：宿命对决', date: '2024-03-05' },
    ],
    rating: 9.5,
    views: 3800000,
    status: '连载中',
    updateDate: '2024-03-05',
    featured: true,
  },
  {
    id: 9,
    title: '甜蜜的校园',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20romance%20style%20cute%20school%20couple%20holding%20hands%20in%20classroom%20after%20school%20warm%20sunset%20lighting%20sweet%20atmosphere%20illustration%20clean%20simple%20background&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    description: '学霸少女遇到了全校最受欢迎的校草，原本毫无交集的两人因为一次意外被分到同一组做课题。在朝夕相处中，两人之间萌生了微妙的感情。这是一部充满青春气息的校园恋爱故事。',
    categories: ['romance', 'comedy'],
    chapters: [
      { num: 1, title: '第1话：分组的命运', date: '2024-02-15' },
      { num: 2, title: '第2话：图书馆偶遇', date: '2024-02-22' },
      { num: 3, title: '第3话：第一次约会', date: '2024-03-01' },
    ],
    rating: 9.0,
    views: 1200000,
    status: '连载中',
    updateDate: '2024-03-01',
    featured: false,
  },
  {
    id: 10,
    title: '暗黑系恋人',
    author: '崔志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20mystery%20style%20dark%20atmosphere%20man%20and%20woman%20in%20shadow%20suspenseful%20noir%20style%20rainy%20night%20city%20street%20moody%20illustration%20clean%20composition&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    description: '刑警李正宇在调查连环杀人案时，发现所有线索都指向他深爱的女友。她究竟是温柔体贴的恋人，还是隐藏着黑暗秘密的凶手？当爱情与真相发生冲突，他该如何选择？',
    categories: ['thriller', 'drama', 'romance'],
    chapters: [
      { num: 1, title: '第1话：血月之夜', date: '2024-02-20' },
      { num: 2, title: '第2话：蛛丝马迹', date: '2024-02-27' },
      { num: 3, title: '第3话：嫌疑', date: '2024-03-05' },
      { num: 4, title: '第4话：双重人格', date: '2024-03-12' },
      { num: 5, title: '第5话：真相', date: '2024-03-19' },
    ],
    rating: 9.1,
    views: 2100000,
    status: '连载中',
    updateDate: '2024-03-19',
    featured: false,
  },
  {
    id: 11,
    title: '异世界美食家',
    author: '姜道贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comedy%20style%20chef%20in%20fantasy%20world%20cooking%20magical%20ingredients%20colorful%20whimsical%20atmosphere%20bright%20illustration%20clean%20simple%20background&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    description: '顶级厨师韩智浩在一次意外后穿越到了剑与魔法的异世界。在这个美食文化贫瘠的世界里，他用现代烹饪技术征服了异世界居民的心。冒险、美食与友情，一场舌尖上的奇幻之旅！',
    categories: ['fantasy', 'comedy'],
    chapters: [
      { num: 1, title: '第1话：穿越异世界', date: '2024-02-25' },
      { num: 2, title: '第2话：第一道菜', date: '2024-03-03' },
      { num: 3, title: '第3话：美食的魔力', date: '2024-03-10' },
      { num: 4, title: '第4话：厨艺对决', date: '2024-03-17' },
    ],
    rating: 8.9,
    views: 980000,
    status: '连载中',
    updateDate: '2024-03-17',
    featured: false,
  },
  {
    id: 12,
    title: '恋与制作人',
    author: '尹智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20drama%20style%20beautiful%20woman%20with%20four%20handsome%20men%20in%20business%20suits%20office%20setting%20elegant%20atmosphere%20beautiful%20illustration%20clean%20composition&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    description: '游戏公司菜鸟策划林允儿接手了一个濒临失败的项目。在重塑游戏的过程中，她与四位性格各异的男主角产生了复杂的感情纠葛。职场与爱情的双重考验，她能否找到属于自己的幸福？',
    categories: ['romance', 'drama'],
    chapters: [
      { num: 1, title: '第1话：项目危机', date: '2024-03-01' },
      { num: 2, title: '第2话：四位男神', date: '2024-03-08' },
      { num: 3, title: '第3话：心动信号', date: '2024-03-15' },
    ],
    rating: 8.8,
    views: 860000,
    status: '已完结',
    updateDate: '2024-03-15',
    featured: false,
  },
];

export const aboutData = {
  brandName: '基德漫画网',
  brandIntro: '基德漫画网成立于2020年，是国内领先的韩漫在线阅读平台。我们致力于为广大漫画爱好者提供最新、最全、最高质量的韩漫资源，让每一位读者都能在这里找到自己喜爱的作品。',
  mission: '让好漫画触手可及，为读者提供极致的阅读体验。',
  vision: '成为中文世界最受欢迎的韩漫阅读社区。',
  stats: [
    { label: '漫画作品', value: '5,000+' },
    { label: '注册用户', value: '120万+' },
    { label: '日均访问', value: '50万+' },
    { label: '好评率', value: '98.5%' },
  ],
  features: [
    { title: '海量资源', description: '收录超过5000部优质韩漫，每日持续更新，涵盖恋爱、奇幻、热血、剧情等多种类型。', icon: 'ri-book-open-line' },
    { title: '流畅阅读', description: '独家下拉式阅读模式，无需翻页，一气呵成。配合智能预加载技术，让阅读更加流畅。', icon: 'ri-book-read-line' },
    { title: '高清画质', description: '所有漫画均提供高清画质，完美还原原作细节，让每一格画面都清晰震撼。', icon: 'ri-hd-line' },
    { title: '免费阅读', description: '坚持免费阅读的理念，让每一位热爱漫画的读者都能无障碍地享受阅读的乐趣。', icon: 'ri-heart-line' },
  ],
  faqs: [
    {
      question: '基德漫画网的漫画都是免费的吗？',
      answer: '是的，基德漫画网所有漫画均免费提供在线阅读。我们致力于为漫画爱好者提供无障碍的阅读体验，无需付费即可畅享海量韩漫资源。',
    },
    {
      question: '什么是下拉式阅读模式？',
      answer: '下拉式阅读是基德漫画网独家优化的阅读体验，所有漫画内容在一个页面内垂直排列，您只需向下滚动即可连续阅读，无需频繁翻页，让阅读更加沉浸流畅。',
    },
    {
      question: '支持哪些设备阅读？',
      answer: '基德漫画网完美适配电脑、平板和手机等各类设备。无论是在家使用电脑大屏阅读，还是外出时用手机随时随地追漫，都能获得优质的阅读体验。',
    },
    {
      question: '漫画多久更新一次？',
      answer: '不同漫画的更新频率不同，热门连载漫画通常每周更新一话。您可以在漫画详情页查看具体的更新时间和更新计划。建议关注喜欢的漫画，以便第一时间收到更新通知。',
    },
    {
      question: '可以在基德漫画网投稿原创漫画吗？',
      answer: '我们非常欢迎优秀的原创漫画作者加入基德漫画网！如有投稿意向，请通过关于我们页面的联系方式与我们取得联系，我们的编辑团队会尽快给您回复。',
    },
  ],
  contact: {
    email: 'contact@jidemanhua.com',
    wechat: '基德漫画官方',
    weibo: '@基德漫画网',
    address: '广东省深圳市南山区科技园路1号',
  },
};